import { Alert, AlertProps, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { BodyTextM, HeadingXL } from "../Typography";

export const Wrapper = styled(
    Stack,
    styledOmitPropsOptions,
)(() => ({
    display: "flex",
    maxWidth: "700px",
    maxHeight: "544px",
    margin: "48px auto 48px auto",
    textAlign: "center",
    alignItems: "center",
}));

export const Title = styled(HeadingXL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(5),
}));

export const Paragraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(5),
}));

export const Bold = styled(BodyTextM)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

export const AlertWrapper = styled((props: AlertProps) => <Alert severity="warning" {...props} />)(({ theme }) => ({
    marginBottom: theme.spacing(5),
    textAlign: "left",
}));
